export const documentFilterJson = {
  provider: 0,
  providerId: 0,
  docType: 0,
  PageSize: 10,
  PageNo: 1,
};

export const documentJson = {
  provider: 0,
  providerid: 0,
  documentType: "",
  document: "",
  documentName: "",
  FolderName: "",
};
